module.exports = __webpack_public_path__ + "img/views.5da232d2.svg";